import { render, staticRenderFns } from "./ProjectCard.vue?vue&type=template&id=8c5ba132&scoped=true&"
import script from "./ProjectCard.vue?vue&type=script&lang=ts&"
export * from "./ProjectCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectCard.vue?vue&type=style&index=0&id=8c5ba132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5ba132",
  null
  
)

export default component.exports